import React from 'react';
import {Link} from 'react-router-dom'
import logoNegroWeb from '../assets/img/logo_negro_web.png';


const IndioLogo = () => {
    return (
        <Link className="skip-link" to="/">
            <section className="logo">
                <img src={logoNegroWeb} alt="Indio" />
            </section>
        </Link>

    );
}

export default IndioLogo;